'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductDescription = exports.PRODUCT_DESCRIPTION_ACCORDIONS = exports.PARALLAX_IMAGES = exports.CONTAINER_SELECTOR = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _ShopifySection2 = require('./../ShopifySection');

var _Accordion = require('./../../objects/content/Accordion');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *  Product Description
 *    Scripts to create a paralax effect for images plus accordions.
 *
 *  Version:
 *    1.0.0 - 2020/07/07
 */

var CONTAINER_SELECTOR = exports.CONTAINER_SELECTOR = '[data-product-description]';
var PARALLAX_IMAGES = exports.PARALLAX_IMAGES = '[data-product-description-image]';
var PRODUCT_DESCRIPTION_ACCORDIONS = exports.PRODUCT_DESCRIPTION_ACCORDIONS = '[data-product-description-accordions]';

var ProductDescription = exports.ProductDescription = function (_ShopifySection) {
  (0, _inherits3.default)(ProductDescription, _ShopifySection);

  function ProductDescription(container) {
    (0, _classCallCheck3.default)(this, ProductDescription);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ProductDescription.__proto__ || Object.getPrototypeOf(ProductDescription)).call(this, container));

    _this.images = container.find(PARALLAX_IMAGES);
    _this.factors = [-0.2, -0.5]; // How much you want to move based on percent

    _this.accordionElement = container.find(PRODUCT_DESCRIPTION_ACCORDIONS);
    if (_this.accordionElement.length) {
      _this.accordions = new _Accordion.Accordion(_this.accordionElement);
    }

    _this.updateParallax();
    return _this;
  }

  (0, _createClass3.default)(ProductDescription, [{
    key: 'updateParallax',
    value: function updateParallax() {
      var _this2 = this;

      var rect = this.container[0].getBoundingClientRect();
      var top = rect.top;

      if (top != this.top) {
        var sTop = $(window).scrollTop();
        var eBottom = rect.bottom;
        var containerTop = this.container.offset().top;

        //Is this section in view?
        var visible = top < window.innerHeight && eBottom >= 0;

        if (visible) {
          var percent = (sTop + rect.height - containerTop) / rect.height * 100;

          this.images.each(function (i, e) {
            var self = $(e);
            self.css({
              "transform": 'translateY(' + (percent * _this2.factors[i]).toFixed(1) + '%)',
              "-webkit-transform": 'translateY(' + (percent * _this2.factors[i]).toFixed(1) + '%)'
            });
          });
        }
      }

      this.top = top;
      requestAnimationFrame(function () {
        return _this2.updateParallax();
      });
    }
  }]);
  return ProductDescription;
}(_ShopifySection2.ShopifySection);

(0, _ShopifySection2.register)(CONTAINER_SELECTOR, ProductDescription);